<template>
  <div class="mui-form form--recipe">
    <fieldset>
      <div class="form-group error required field-text-area">
        <div class="field-wrap">
          <textarea v-model.trim="model.name" type = "text" placeholder="Name" name="name" class="form-control" ref="nameInput" ></textarea>
        </div>
        <span v-if="error.name" class="help is-danger">{{error.name[errors[0]]}}</span>
      </div>
    </fieldset>
    <fieldset>
      <div class="form-group field-text">
        <label>Yield</label>
        <div class="field-wrap">
          <input v-model="model.recipeYield" type="text" placeholder="Add recipe yield" name="recipeYield" class="form-control">
        </div>
      </div>
    </fieldset>
    <fieldset>
      <div class="form-group field-text">
        <label>Prep Time</label>
        <div class="field-wrap">
          <input v-model="model.prepTime" type="text" placeholder="Add prep time in minutes" name="prepTime" class="form-control">
        </div>
      </div>
      <div class="form-group field-text">
        <label>Cook Time</label>
        <div class="field-wrap">
          <input v-model="model.cookTime" type="text" placeholder="Add cook time in minutes" name="cookTime" class="form-control">
        </div>
      </div>
      <div class="form-group field-text">
        <label>Total Time</label>
        <div class="field-wrap">
          <input v-model="model.totalTime" type="text" placeholder="Add total time in minutes" name="totalTime" class="form-control" ref="totalTime">
        </div>
      </div>
    </fieldset>
    <fieldset>
      <div class="form-group field-list form-group--ingredients">
        <label>Ingredients</label>
        <MUIContentEditableList
          placeholder="Add an ingredient"
          ref="ingredients"
          type="ingredients"
          :items="model.ingredients"
          @input="contentEditableListInputHandler" />
      </div>
    </fieldset>
    <fieldset>
      <div class="form-group field-list form-group--instructions">
        <label>Instructions</label>
        <MUIContentEditableList
          placeholder="Add an instruction"
          ref="instructions"
          tag="ol"
          type="instructions"
          :items="model.instructions"
          @input="contentEditableListInputHandler" />
      </div>
    </fieldset>
    <fieldset>
      <div class="form-group field-text-area">
        <label>Notes</label>
        <div class="field-wrap">
          <textarea v-model="model.notes" placeholder="Add a note" rows="1" name="notes" class="form-control"></textarea>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import autosize from 'autosize'
import CMButton from '../components/CMButton'
import MUIContentEditableList from '../components/MUIContentEditableList'
import { errorMessages } from '@/utils'

const initialModel = () => {
  return {
    name: undefined,
    prepTime: undefined,
    cookTime: undefined,
    totalTime: undefined,
    recipeYield: undefined,
    ingredients: [],
    instructions: [],
    notes: undefined
  }
}

export default {
  props: [
    'recipeKey'
  ],
  components: {
    CMButton,
    MUIContentEditableList
  },
  data () {
    return {
      model: this.buildModel(),
      syncModel: {},
      errors: []
    }
  },
  computed: {
    error () {
      return this.errors.length > 0 && errorMessages().recipe
    }
  },
  methods: {
    buildModel () {
      const state = this.$store.state
      const recipe = this.recipeKey && state.Recipe.items[this.recipeKey]
      if (!recipe) return initialModel()

      // Deep clone the recipe
      let clonedRecipe = JSON.parse(JSON.stringify(recipe))
      if (Array.isArray(clonedRecipe.notes)) {
        clonedRecipe.notes = clonedRecipe.notes.join('\n')
      }
      return Object.assign(initialModel(), clonedRecipe)

      // TODO: Remove once all recipe data schemas match
      // if (typeof model.ingredients[0] === 'string') {
      //   model.ingredients = model.ingredients.map(item => {
      //     return { text: item.trim() }
      //   })
      // }
      //
      // if (typeof model.instructions[0] === 'string') {
      //   model.instructions = model.instructions.map(item => {
      //     return { text: item.trim() }
      //   })
      // }
    },
    contentEditableListInputHandler (ev) {
      this.syncModel[ev.type] = ev.value
    },
    validate () {
      if (!this.model.name) {
        this.errors.push('required')
        return
      }
      Object.assign(this.model, this.syncModel)
    }
  },
  mounted () {
    autosize(document.querySelectorAll('textarea'))
  },
  watch: {
    'model.name' () {
      if (!this.model.name) return
      this.errors.pop('required')
      this.errors = [...new Set(this.errors)]
    },
    syncModel () {
      // console.log(this.syncModel)
    }
  }
}
</script>
<style lang="sass">
@import "../styles/variables.scss"
.form--recipe
  input[name=name], textarea[name=name]
    font-family: $bodyFontFamily
    font-size: 24px
    line-height: 32px
    font-weight: 300
</style>



// WEBPACK FOOTER //
// src/components/RecipeForm.vue